import store from "@/store";
import { CHANNEL_TYPES, STATIC_CHANNEL_ID } from '@/common/constants/channel';
import { findChannelBaseInfo } from "_api/channel";
import { checkIsNotShow } from '@/views/room/utils';

export function findChannelByMsg (channel_id, user_id, channels) {
  if (!channel_id && !user_id) return undefined
  const msg_channels = store.getters.msg_channels
  if (user_id) {
    return findUserInChannel(user_id, channels) || msg_channels[user_id]
  }
  if (channel_id) {
    return findChannelSync(channel_id, channels) || msg_channels[channel_id]
  }
  return undefined
}
/**
 * 仅从传入的channels查找频道数据，引用数据
 * @description 仅从当前本地数据查找频道数据，不进行异步请求
 * @param {string} id 频道id
 * @param {Array} channels 本地的数据列表
 * @param {boolean} [isFlat=true] 是否扁平化结构 默认为true
 * @param {boolean} [useVuex=true] 是否使用vuex 默认为true
 * @returns channels中对应id的引用
 */
export function findChannelSync(id, channels, isFlat = true, useVuex = true) {
  if (!id) return undefined
  if (!channels || !Array.isArray(channels) || channels.length === 0) {
    channels = useVuex ? store.getters.channels : []
  }
  if (store.getters.cur_resource_channel_data.channel_id && (id === store.getters.cur_resource_channel_data.channel_id)) {
    return store.getters.cur_resource_channel_data
  }
  if(isFlat) {
    return channels.find(v => v.channel_id === id)
  } else {
    for(let channel of channels) {
      if(channel.channel_id === id) {
        return channel
      } else if(channel.channel_list) {
        for(let sub of channel.channel_list) {
          if(sub.channel_id === id) {
            return sub
          }
        }
      }
    }
  }
}

/**
 * 请求后端接口获取该频道数据，非引用
 * @param {string} id 频道id
 * @returns 后端返回的频道数据
 */
export async function findChannelAsync(id) {
  const {
    data: {
      status, result
    }} = await findChannelBaseInfo(
      {},
      {
        _notip: 1,
        room_id: store.getters.cur_room_data.room_id,
        channel_ids: [id],
      }
    )
  if(status === 'ok') {
    const channel = result.channels[0]
    if(channel) {
      const tempRoleId = store.getters.temp_role_data.temp_role?.id
      const [notShowResult, detail] = checkIsNotShow(channel, store.getters.cur_room_whole_data, { tempRoleId, needExit: false })
      channel['not_show'] = notShowResult
      channel['not_show_detail'] = detail
    }
    return channel
  }
  return undefined
}

/**
 * 找出频道数据
 * @description 根据频道id，先进行匹配静态频道数据，如果匹配不到，则进行房间频道数据的匹配
 * @param {string} id 频道id
 * @param {Array} channels 频道数据列表 扁平结构
 * @returns 返回频道数据 直接修改可能会不生效，因为可能不是引用
 */
export async function findChannel(id, channels) {
  if (!id) return undefined
  if(Object.keys(STATIC_CHANNEL_ID).includes(id)){
    return {
      channel_type: CHANNEL_TYPES[id],
    }
  }
  const result = findChannelSync(id, channels)
  if(result) {
    return result
  }
  // 是否需要异步
  let needAsync = checkHasFullChannels()
  if(needAsync) {
    return await findChannelAsync(id)
  }
  return undefined
}

/**
 * 判断当前的房间是否已经获取到全量的频道数据
 * @returns 
 */
export function checkHasFullChannels() {
  const { channels, cur_room_data, cur_room_data_is_big } = store.getters
  if(cur_room_data_is_big) {
    return channels.length < cur_room_data.channel_count;
  } else {
    return false;
  }
}

function isSameType (channel_type, types) {
  if (Array.isArray(types)) {
    return types.includes(channel_type)
  }
  return channel_type === types
}

export function findChannelByType(type, channels) { 
  if (!type) return []
  if (!channels) {
    channels = store.getters.channels
  }

  if (CHANNEL_TYPES[type] === undefined) {
    return []
  }
  let results = []
  for (let channel of channels) {
    if (isSameType(channel.channel_type, CHANNEL_TYPES[type])) {
      results.push(channel)
    } else if (channel.channel_list && channel.channel_list.length) {
      results.push(...findChannelByType(type, channel.channel_list))
    }
  }
  return results
}

// 用于频道拖拽的 TODO 后续应该会弃用
export function findChannelIndex(id, channels) {
  if (!id) return undefined
  if (!channels) {
    channels = store.getters.channels
  }
  for (let index in channels) {
    let channel = channels[index]
    if (channel.channel_id == id) {
      return {
        index: parseInt(index),
        channel
      }
    }
    if (channel.channel_list) {
      for (let sub_index in channel.channel_list) {
        let c = channel.channel_list[sub_index]
        if (c.channel_id == id) {
          return {
            index: parseInt(index),
            sub_index: parseInt(sub_index),
            channel: c
          }
        }
      }
    }
  }
}

export function checkIsAudioChannel(channel) {
  return CHANNEL_TYPES.has_audio_types.includes(channel.channel_type)
}
export function checkInMembers(channel, user_id) {
  const members = (channel.members?.length ? channel.members : channel.collapse_members) || []
  return members.some(member => member.user_id == user_id)
}
export function findUserInChannel(user_id, channels) {
  if (!user_id) return undefined
  if (!channels) {
    channels = store.getters.channels
  }
  for (let i = 0; i < channels.length; i++) {
    const channel = channels[i]
    if (channel.not_show_detail?.permissionNotShow) continue
    if (checkIsAudioChannel(channel) && checkInMembers(channel, user_id)) {
      return channel
    } 
    // else if (channel.channel_type === CHANNEL_TYPES.group) {
    //   const sub_channels = channel.channel_list || []
    //   for (let j = 0; j < sub_channels.length; j++) {
    //     const sub_channel = sub_channels[j]
    //     if (sub_channel.not_show_detail?.permissionNotShow) continue
    //     if (checkIsAudioChannel(sub_channel) && checkInMembers(sub_channel, user_id)) {
    //       return sub_channel
    //     }
    //   }
    // }
  }
  return undefined
}
// 判断是否为可以在频道管理中编辑设置的频道
export function checkIsCanEditChannel(channel){
  if(!channel) return false
  return CHANNEL_TYPES.can_edit_types.includes(channel.channel_type)
}

// 判断是否为可以在频道管理中编辑音频设置的频道
export function checkIsCanEditAudioChannel(channel){
  if(!channel) return false
  return CHANNEL_TYPES.can_edit_audio_types.includes(channel.channel_type)
}